import styled from 'styled-components';
import {Divider} from '../../atoms';

export const CardMain = styled.div`
  height: 80px;
  margin-bottom: 12px;
  border-radius: 4px;
  background-color: white;
  display: flex;
  cursor: pointer;
`;

export const TopDivider = styled(Divider)`
  color: ${props => props.theme.colors.primary};
  width: 15%;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  width: 80%;
  padding: 16px 28px;
  letter-spacing: 0.08em;
`;

export const SystemType = styled.div`
  font-weight: bold;
  font-size: 16px;
  margin-top: 6px;
  margin-bottom: 8px;
  color: ${props => props.theme.colors.primary};
`;
